export const apiMethods = [
    {
        name: 'PlayerLogin',
        method: 'PlayerLogin',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'email',
                processArgs: val => val,
            },
            {
                name: 'password',
                processArgs: val => btoa(val), // base64 encode the password
            },
            {
                name: 'terms_check',
                processArgs: val => val,
            },
            {
                name: 'form_submitted',
                processArgs: () => 1,
            },
        ],
    },
    {
        name: 'ValidateTicket',
        method: 'ValidateTicket',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'ticket1_1_1',
                processArgs: val => val,
            },
            {
                name: 'ticket1_2_1',
                processArgs: val => val,
            },
            {
                name: 'entry_method',
                processArgs: val => val || '',
            },
            {
                name: 'form_submitted',
                processArgs: () => '1',
            },
            {
                name: 'entry-submit',
                processArgs: () => 'SUBMIT+ENTRY',
            },
            {
                name: 'promotion',
                processArgs: val => val,
            },
        ],
    },
    {
        name: 'MyEntries',
        method: 'MyEntries',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: (val) => val,
            },
            {
                name: 'draw_number',
                processArgs: (val) => val,
            },
        ],
    },
    {
        name: 'PlayerData',
        method: 'PlayerData',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'PlayerLogout',
        method: 'PlayerLogout',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'SetEntryFlashGameFlag',
        method: 'SetEntryFlashGameFlag',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: val => val,
            },
            {
                name: 'entry_id',
                processArgs: val => val,
            },
            {
                name: 'flag',
                processArgs: val => val,
            },
        ],
    },
    {
        name: 'Winners',
        method: 'Winners',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'game_id',
                processArgs: val => val,
            },
            {
                name: 'draw_number',
                processArgs: val => val,
            },
            {
                name: 'draw_date',
                processArgs: val => val,
            },
        ],
    },
    {
        name: 'Drawings',
        method: 'Drawings',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'promotion',
                processArgs: () => 'monopoly',
            },
        ],
    },
    {
        name: 'PlayerCancelToken',
        method: 'PlayerCancelToken',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [],
    },
    {
        name: 'PlayerCancel',
        method: 'PlayerCancel',
        action: 'post',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'token',
                processArgs: val => val,
            },
        ],
    },
    {
        name: 'SetEntryFlashGameFlag',
        method: 'SetEntryFlashGameFlag',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'entry_id',
                processArgs: val => val,
            },
        ],
    },
    {
        name: 'RollingJackpots',
        method: 'rollingjackpots',
        action: 'get',
        postBuild: (postingData, requestObj) => requestObj,
        postRequest: (err, res) => {},
        args: [
            {
                name: 'promo_id',
                processArgs: val => 1574,
            },
        ],
    },
];
